import { render, staticRenderFns } from "./LayoutList.vue?vue&type=template&id=4548b244&scoped=true&"
import script from "./LayoutList.vue?vue&type=script&lang=js&"
export * from "./LayoutList.vue?vue&type=script&lang=js&"
import style0 from "./LayoutList.vue?vue&type=style&index=0&id=4548b244&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4548b244",
  null
  
)

export default component.exports